/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RoleEnumDto {
  ORGANIZATION_ADMIN = 'OrganizationAdmin',
  DEPARTMENT_ADMIN = 'DepartmentAdmin',
  REGISTRATOR = 'Registrator',
  SURVEYOR = 'Surveyor',
  SUPERVISOR = 'Supervisor',
  NOT_SET = 'NotSet',
}
